export const isLoad = (process) => {
  return process?.direction === 'LOAD';
};

export const isUnload = (process) => {
  return process?.direction === 'UNLOAD';
};

export const isContainer = (process) => {
  return process?.container_type?.toUpperCase() === 'CONTAINER';
};

export const isTrailer = (process) => {
  return process?.container_type?.toUpperCase() === 'TRAILER';
};


export const PROCESS_DIRECTION_LABELS = {
  UNLOAD: 'Inbound',
  LOAD: 'Outbound',
};

export const EQUIPMENT_TYPE_LABELS = {
  CONTAINER: 'Container',
  TRAILER: 'Trailer',
};